import { getDecryptedUserDetails } from "@/ts/utils";

export const useUserTimezone = (timezone?: string) => {
    const userData = getDecryptedUserDetails();
    const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const userTimezone = userData.timezone;
    const resolvedTimezone = localTimezone || userTimezone || timezone || "Asia/Kolkata";
    return resolvedTimezone;
};
